
import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { copyTextToClipboard } from '../../../utils/function/copyToClipboard';
const { TextArea } = Input;

const TextAreaWithCopyButton = ({
  value = '',
  onChange,
  placeholder = 'Enter text',
  rows = 4,
  ...props
}) => {
  const [textValue, setTextValue] = useState(value);
  const copySourceBtnRef = useRef(null);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setTextValue(newValue);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div
      className="position-relative"
      onMouseEnter={() => {
        if (!copySourceBtnRef.current) {
          return;
        }
        copySourceBtnRef?.current?.classList?.add('d-block');
        copySourceBtnRef?.current?.classList?.remove('d-none');
      }}
      onMouseLeave={() => {
        if (!copySourceBtnRef.current) {
          return;
        }
        copySourceBtnRef?.current?.classList?.remove('d-block');
        copySourceBtnRef?.current?.classList?.add('d-none');
      }}>
      <TextArea
        value={textValue}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        className="pr-10"

        {...props}
      />
      {textValue && (
        <Button
          ref={copySourceBtnRef}
          icon={<CopyOutlined className="fs-sm"/>}
          type="primary"
          size="small"
          style={{ right: 10, top: 10 }}
          onClick={() => {
            copyTextToClipboard(value);
          }}
          className="position-absolute z-index-popover d-none shadow p-0">
        </Button>
      )}
    </div>
  );
};

TextAreaWithCopyButton.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  rows: PropTypes.number
};

export default TextAreaWithCopyButton;
